import * as React from "react";

export const WarningSign: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "#23252A",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    color={color}
    {...rest}
  >
    <g clipPath="url(#clip0_16612_24525)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M10 10.933V7.817"
      ></path>
      <path
        fill="currentColor"
        d="M9.997 13.333A.834.834 0 1 0 10.004 15a.834.834 0 0 0-.007-1.666"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="m11.691 3.45 6.382 11.17c.742 1.298-.195 2.913-1.69 2.913H3.618c-1.496 0-2.434-1.616-1.691-2.914L8.309 3.45c.748-1.309 2.635-1.309 3.382 0"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_16612_24525">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
